<template>
    <v-btn
        class="tw-aspect-square tw-h-auto tw-max-h-none tw-w-full tw-items-end tw-rounded-lg tw-pb-5 tw-text-xs tw-font-bold"
        :color="category.color"
        :to="toCategoryPage || undefined">
        <CategoryName
            :category="category"
            class="sm:tw-text-xl" />
    </v-btn>
</template>

<script setup lang="ts">
    import type { Category } from '@/configs/categories';
    import _ from 'lodash';

    const props = defineProps<{
        category: Category;
    }>();

    const toCategoryPage = computed(() => {
        return _.get(props.category, 'toCategoryPage', false);
    });
</script>

<style scoped></style>
